import {ChangeDetectorRef, Component} from "@angular/core";
import {Page} from "../../../../orchestration/page";
import {SessionModel} from "../../../../orchestration/session.model";
import {NavigationService} from "../../../../orchestration/navigation.service";
import {NotificationService} from "../../../../notification/notification.service";
import {MenuModel} from "../../../../menu/menu.model";
import {OrderModel} from "../../../order.model";
import {OrchestrationEvents} from "../../../../orchestration/orchestration-events";
import {NavigationParams} from "../../../../orchestration/navigation-params";
import {OrderItem} from "../../../order";
import {MenuExtraGroupData, MenuExtraProductData} from "../../../../menu/menu-entity.model";

@Component({
    selector: "woa-order-item-extra-sizes-edit-page",
    templateUrl: "./order-item-extra-sizes-edit-page.component.html",
    providers: [{provide: Page, useExisting: OrderItemExtraSizesEditPageComponent}]
})
export class OrderItemExtraSizesEditPageComponent extends Page {
    SessionModel = SessionModel;
    OrchestrationEvents = OrchestrationEvents;

    public groupName: String;
    public anyHaveImages: boolean;
    public extra: MenuExtraGroupData;
    public selectedExtraProduct: MenuExtraProductData;
    public originalSelectedExtraProduct: MenuExtraProductData;
    public availableExtraProducts: MenuExtraProductData[];

    private readonly orderItem: OrderItem;

    constructor(navigationParams: NavigationParams,
                public menuModel: MenuModel,
                public navigationService: NavigationService,
                public notificationService: NotificationService,
                private orderModel: OrderModel,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
        this.orderItem = navigationParams.get("orderItem");
        this.extra = navigationParams.get("extra");
        this.selectedExtraProduct = navigationParams.get("selectedExtraProduct");
        this.originalSelectedExtraProduct = this.selectedExtraProduct;
        this.availableExtraProducts = navigationParams.get("availableExtraProducts");
        this.groupName = navigationParams.get("groupName");

        this.anyHaveImages = this.availableExtraProducts.some((extraProduct: MenuExtraProductData) => !!this.menuModel.getStandardItemImage(extraProduct.menuItem));
    }

    showExtraUnavailable(extraProduct: MenuExtraProductData): boolean {
        return extraProduct.productLine.sellableId !== this.selectedExtraProduct.productLine.sellableId && !this.canSelectExtra(extraProduct);
    }

    canSelectExtra(extraProduct: MenuExtraProductData): boolean {
        return !this.extraProductAtLimit(extraProduct);
    }

    extraProductAtLimit(extraProduct: MenuExtraProductData): boolean {
        if (!this.orderItem || extraProduct === this.originalSelectedExtraProduct) {
            return false;
        }
        return this.orderModel.sellableAtLimit(extraProduct.menuItem ? extraProduct.menuItem.sellable.sellableId : extraProduct.productLine.sellableId, this.orderItem.quantity, this.orderItem.sellableQtyOrdered(this .orderItem.quantity, extraProduct.productLine.sellableId));
    }

    selectExtra(extraProduct: MenuExtraProductData): void {
        if (this.selectedExtraProduct === extraProduct) {
            event.preventDefault();
            return;
        }

        if (!this.canSelectExtra(extraProduct)) {
            if (this.menuModel.itemOutOfStock(extraProduct.menuItem)) {
                // noinspection JSIgnoredPromiseFromCall
                this.notificationService.displayAlert(null, "woa.message.order.productOutOfStock", {item: extraProduct.menuItem.name});
            } else if (this.extraProductAtLimit(extraProduct)) {
                // noinspection JSIgnoredPromiseFromCall
                this.notificationService.displayAlert(null, "woa.message.order.productLimitReached", {item: extraProduct.menuItem.name});
            }
            event.preventDefault();
            return;
        }

        this.selectedExtraProduct = extraProduct;
        this.changeDetectorRef.detectChanges();
    }

    getExtraPrice(extra: MenuExtraGroupData, extraProduct: MenuExtraProductData): number {
        if (OrderModel.SHOW_RELATIVE_PRICING_FOR_EXTRA_SIZES) {
            const value: number = extraProduct.price - this.orderItem.getBasePriceForGroup(extra.id);
            return value !== 0 ? value : undefined;
        }
        return extraProduct.price;
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-item/order-item-options-panel/order-item-extra-sizes-edit-page/order-item-extra-sizes-edit-page.component.ts